import { render, staticRenderFns } from "./charge-detail.vue?vue&type=template&id=62383be0&scoped=true"
import script from "./charge-detail.vue?vue&type=script&lang=js"
export * from "./charge-detail.vue?vue&type=script&lang=js"
import style0 from "./charge-detail.vue?vue&type=style&index=0&id=62383be0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62383be0",
  null
  
)

export default component.exports